import type { ModuleSlug } from '@/styles/tokens';
import { DEFAULT_MODULE_TREE } from '@/shared/modules/catalog';
import {
  deriveModuleLabels,
  deriveModuleTiles,
  deriveSwitcher,
  type ModuleDef,
} from '@/shared/modules/registries';

/**
 * The Amassa module registry, as the shell reads it. Every value here is
 * DERIVED from `shared/modules/catalog.json` (`shared/modules/registries.ts`);
 * change a module there, never here.
 *
 * `tile` is the canonical PHP tile slug used by `canSeeTile()`. Dashboard
 * is the OS home (the Amassa chip), not a module, so it lives apart.
 */
export type { ModuleDef };

export const HOME = {
  to: '/dashboard',
  label: 'Hub',
  blurb: 'Every thread, one loom',
} as const;

/**
 * Human label for EVERY module slug, including the five that are not in
 * `MODULES` (they are reachable from the Hub-home tiles, not the switcher):
 * the module's `shortLabel ?? label`. The sidebar, the Topbar breadcrumb and
 * the ⌘K launcher all read it.
 */
export const MODULE_LABEL: Record<ModuleSlug, string> = deriveModuleLabels(DEFAULT_MODULE_TREE);

/**
 * Route slug → canonical PHP tile slug, for EVERY module. `canSeeTile()`
 * speaks tile slugs, not route slugs, so anything gating a module surface
 * outside the switcher (the top bar's Hot Plate button, `RequireTile`)
 * resolves through here.
 */
export const MODULE_TILE: Record<ModuleSlug, string> = deriveModuleTiles(DEFAULT_MODULE_TREE);

/** The sidebar's module switcher, in Hub order (modules with `switcher`). */
export const MODULES: ModuleDef[] = deriveSwitcher(DEFAULT_MODULE_TREE);
